import { useLocation } from 'react-router-dom';
import { getMatchedRoute } from './routeMeta';

/**
 * Get the Route Object of active Route.
 * @returns {Object} Route Object
 */
const useMatchedRoute = (RoutesItems) => {
  const { pathname } = useLocation();
  return getMatchedRoute(pathname, RoutesItems) || {};
};
export default useMatchedRoute;
